<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<div class="card rounded-2">
	<div class="card-body bg-gray-200 p-4">

		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade" id="client_manager_pane_1" role="tabpanel">
				<div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
					<button type="button" class="btn btn-primary btn-lg" (click)="openAddClientModal()">
						<i class="ki-duotone ki-plus fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
							<span class="path3"></span>
						</i>
						Add New Client
					</button>
				</div>
			</div>
			<div class="tab-pane show active" id="client_manager_pane_2" role="tabpanel">
				<app-client-manage-list #clientManageList (clientUpdated)="onClientUpdated()"></app-client-manage-list>
			</div>
			<div class="tab-pane fade  " id="client_manager_pane_3" role="tabpanel">
				<app-client-export-list></app-client-export-list>
			</div>
		</div>
	</div>
</div>

<app-export-modal></app-export-modal>
<app-edit-client-modal #editClientModal (clientUpdated)="onClientUpdated()"></app-edit-client-modal>
